module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"18\" viewBox=\"0 0 20 18\">\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\">\r\n        <path d=\"M.707 4.2l4.2-4.2L6.32 1.414 2.828 4.907l3.568 3.568-1.414 1.414L0 4.907.707 4.2z\"/>\r\n        <path d=\"M2 16v2h11.002a7 7 0 0 0 0-14H2v2h10.991A5.008 5.008 0 0 1 18 11c0 2.761-2.24 5-5.009 5H2z\"/>\r\n    </g>\r\n</svg>\r\n"


//////////////////
// WEBPACK FOOTER
// ./template/styles/icons/returns.svg
// module id = ./template/styles/icons/returns.svg
// module chunks = client.sitechrome